import EngineModule from '../../../EngineModule';
import {
	NS as StandingPersonalizationEditorNS
}                   from '../../../components/customers/standing/StandingPersonalizationEditor/StandingPersonalizationEditor';

export default () => new EngineModule.UIEngineModule({
	type :             'ui',
	id :               'standing-personalizationEditor',
	dependencies :     [
		'oms-basket',
		'viewer-planner'
	],
	modulesBefore :    [
		'product-editor',
		'viewer-planner-layout-editor',
		'viewer-planner-dimensionsEditor',
		'viewer-planner-floor-editor'
	],
	modulesAfter :     [ 'viewer-planner-walls-editor' ],
	allowedCustomers : [ /* Local MPA */'XUJG0A2TF5', /* Prod */'STAODAZNIS', 'sam1_12345' ],
	usableCondition :  {
		type : 'and',
		LHS :  {
			type :      'notequal',
			component : 'K',
			property :  'TARGET.currentProduct',
			value :     null
		},
		RHS :  {
			type :      'notequal',
			component : 'K',
			property :  '[*]TARGET.currentProduct.getPart(["layout"]).currentOption',
			value :     null
		}
	},
	displayCondition : {
		type :      'notequal',
		component : 'K',
		property :  'TARGET.currentProduct.reference.value',
		value :     'business'
	},
	generateComponentConfiguration() : StandingPersonalizationEditorNS.Configuration {
		return {};
	},
	async initialize() {
	}
});
